export default "mutation updateCategory($updateDto: ResourceTagCategoryUpdateRequest) {\n  updateCategory(updateDto: $updateDto) \n}";